import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-epic-surface/60 backdrop-blur-2xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="font-grotesk font-black tracking-tighter text-2xl md:text-3xl uppercase text-epic-text transition-transform duration-300 hover:scale-105"
        >
          e<span className="text-epic-accent">P</span>IC
        </a>

        <div className="flex items-center gap-3 md:gap-5">
          <a
            href={COMPANY.website}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-website"
            className="hidden sm:inline font-mono text-[11px] md:text-xs uppercase tracking-[0.15em] text-epic-sub transition-colors duration-300 hover:text-epic-text"
          >
            Website
          </a>
          <a
            href={COMPANY.meetingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-book-meeting"
            className="group inline-flex items-center gap-2 bg-epic-accent px-4 md:px-6 py-2.5 md:py-3 text-white font-mono text-[11px] md:text-xs uppercase tracking-[0.15em] transition-[background-color,transform] duration-300 hover:bg-epic-accentHover active:scale-95"
          >
            Book a Meeting
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </motion.header>
  );
};
